import React from 'react';
import PropTypes from 'prop-types';
import { getlocal } from '../../../../base/base/storage';
import styles from './index.css';

class SurveyBar extends React.PureComponent {
    static propTypes = {
        data: PropTypes.object,
        handleClickBar: PropTypes.func,
        isSubmitSurvey: PropTypes.bool,
    };

    state = {
        hasLocalData: false,
    };

    componentDidMount() {
        const { data } = this.props;
        const getlocalVal = getlocal('surveyResultData') || {};

        data?.result?.forEach((qestionItem) => {
            if (Object.keys(getlocalVal).includes(qestionItem.resultArray.questionid)) {
                this.setState({
                    hasLocalData: true,
                });
            }
        });
    }

    render() {
        const { isSubmitSurvey, data, handleClickBar } = this.props;
        const { hasLocalData } = this.state;

        return (
            <div className={styles.surveyBar} onClick={handleClickBar}>
                <div className={styles.head}>
                    <div className={styles.logo} />
                    <div className={styles.more}>
                        {isSubmitSurvey || hasLocalData ? '已参与' : '参与投票'}，查看结果
                    </div>
                </div>
                <div className={styles.title}>{data?.surveyinfo?.title}</div>
            </div>
        );
    }
}

export default SurveyBar;
